var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-chat-form-component",
      class: [
        _vm.type,
        `section-${_vm.section}`,
        { mine: _vm.isMine },
        { fix: _vm.isFixed },
        { whisper: _vm.isWhisper },
        { staff: _vm.isWhisperStaff },
      ],
    },
    [
      !_vm.isMyChat && !_vm.isSystemNoti
        ? _c("div", { staticClass: "room-chat-info" }, [
            _c("span", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.item.nickname,
                  expression: "item.nickname",
                },
              ],
              staticClass: "room-chat-user-nickname sender align-top",
              domProps: { innerHTML: _vm._s(_vm.item.nickname) },
            }),
            _vm.isWhisper
              ? _c("img", {
                  staticClass:
                    "room-chat-user-nickname receiver inline-block pb-1 align-top relative top-1",
                  attrs: {
                    src: require("@/assets/images/camstudy/ico_polygon_gray.svg"),
                    alt: _vm.$t("chat.whisper.target.default"),
                  },
                })
              : _vm._e(),
            _c("span", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.item.receiveUser,
                  expression: "item.receiveUser",
                },
              ],
              staticClass: "room-chat-user-nickname receiver align-top",
              domProps: { innerHTML: _vm._s(_vm.item.receiveUser) },
            }),
            _vm.isWhisper
              ? _c(
                  "span",
                  { staticClass: "room-chat-user-nickname receiver align-top" },
                  [
                    _vm._v(
                      "(" + _vm._s(_vm.$t("chat.whisper.target.default")) + ")"
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "room-chat-form",
          class: { "w-full": _vm.isSystemNoti },
        },
        [
          _c(
            "div",
            { staticClass: "relative avatar-container" },
            [
              !_vm.isMyChat && !_vm.isSystemNoti
                ? _c("GrmAvatar", {
                    attrs: { icon: _vm.profileIcon, src: _vm.avatarSrc },
                  })
                : _vm._e(),
              _vm.isOpener(_vm.item.userId) &&
              !_vm.item.isFile &&
              !_vm.isSystemNoti
                ? _c("div", { staticClass: "icon-container" })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "room-chat" },
            [
              _vm.isMyChat && !_vm.isSystemNoti
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "room-chat-message-wrapper",
                        staticStyle: { opacity: "0.6" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "room-chat-message-loading" },
                          [
                            _c(
                              "p",
                              { staticClass: "room-chat-message-loading-text" },
                              [_vm._v(_vm._s(_vm.$t("chat.form.sending")))]
                            ),
                          ]
                        ),
                        _c("pre", {
                          staticClass: "room-chat-message me",
                          domProps: { innerHTML: _vm._s(_vm.item.myChats) },
                        }),
                      ]
                    ),
                  ]
                : _vm.isSystemNoti
                ? [
                    _c("div", { staticClass: "noti-container" }, [
                      _c("div", { staticClass: "notice-content" }, [
                        _vm._v(" " + _vm._s(_vm.item.content) + " "),
                      ]),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "room-chat-message-wrapper" }, [
                      _c("div", { staticClass: "relative" }, [
                        _c("pre", {
                          staticClass: "room-chat-message",
                          domProps: { innerHTML: _vm._s(_vm.content) },
                        }),
                      ]),
                    ]),
                  ],
            ],
            2
          ),
          _vm.item.receiveDate && !_vm.isSystemNoti
            ? _c("p", { staticClass: "room-chat-time" }, [
                _vm._v(_vm._s(_vm.item.receiveDate)),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }